import loadable from '@loadable/component';

import { cn } from '@simplywallst/ui-core/next';

import type { usePortfolioPerformanceTimeseries } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';

import { useResponsiveWidth } from '@/hooks/useResponsiveWidth';

import type { PerformancePeriod } from '../../types';

import { LoadingState as ChartLoadingState } from './LoadingState';

const Chart = loadable(() => import('./Chart'), {
  resolveComponent: (c) => c.Chart,
  fallback: <ChartLoadingState />,
});

const RestrictedChart = loadable(() => import('./RestrictedChart'), {
  resolveComponent: (c) => c.RestrictedChart,
});

interface Props {
  isChartRestricted?: boolean;
  market: string;
  period: PerformancePeriod;
  timeseries: ReturnType<typeof usePortfolioPerformanceTimeseries>['data'];
  timeseriesStatus: 'error' | 'success' | 'pending';
  endTimestamp: number;
  startTimestamp: number;
}

export const Layout = (props: Props) => {
  const { isChartRestricted } = props;
  const chartHeight = 200;
  const { ref, width: chartWidth } = useResponsiveWidth();
  return (
    <div
      ref={ref}
      className={cn(
        'grid gap-x2',
        'grid-rows-[min-content_var(--portfolio-performance-chart-height)]'
      )}
      style={
        {
          '--portfolio-performance-chart-height': `${chartHeight}px`,
        } as React.CSSProperties
      }
    >
      {isChartRestricted ? (
        <RestrictedChart width={chartWidth} height={chartHeight} {...props} />
      ) : (
        <Chart width={chartWidth} height={chartHeight} {...props} />
      )}
    </div>
  );
};
